import { useIntl } from "react-intl";

import { CollapsibleCard } from "@/components/CollapsibleCard/CollapsibleCard";
import { formatCurrency } from "@/utils/currency";

type Props = {
  basePrice: number;
  baseDiscount: number;
  tourPrice?: number;
  promoCodeDiscount?: number;
  totalPrice: number;
};

export function PriceDetailsCard({
  basePrice,
  baseDiscount,
  promoCodeDiscount,
  tourPrice,
  totalPrice,
}: Props) {
  const intl = useIntl();

  return (
    <CollapsibleCard
      title={intl.formatMessage({
        defaultMessage: "Price details",
        description: "trips.priceDetails.title",
      })}
      collapsible={false}
    >
      <dl className="grid grid-cols-2 gap-2 text-sm">
        <dt className="text-text-disabled-primary">
          {intl.formatMessage({
            defaultMessage: "Base trip price",
            description: "trips.basePrice",
          })}
        </dt>
        <dd className="text-end font-bold">{formatCurrency(basePrice)}</dd>

        {tourPrice !== undefined && (
          <>
            <dt className="text-text-disabled-primary">
              {intl.formatMessage({
                defaultMessage: "City tours",
                description: "trips.tours.tourPrice",
              })}
            </dt>
            <dd className="text-end font-bold">{formatCurrency(tourPrice)}</dd>
          </>
        )}

        <dt className="text-text-disabled-primary">
          {intl.formatMessage({
            defaultMessage: "Discount",
            description: "trips.discount",
          })}
        </dt>
        <dd className="text-end font-bold">{formatCurrency(baseDiscount)}</dd>

        {promoCodeDiscount ? (
          <>
            <dt className="text-text-disabled-primary">
              {intl.formatMessage({
                defaultMessage: "Promo code discount",
                description: "promoCode.promoCodeDiscount",
              })}
            </dt>
            <dd className="text-end font-bold text-core-accent-500">
              {formatCurrency(promoCodeDiscount)}
            </dd>
          </>
        ) : null}

        <dt className="text-text-disabled-primary">
          {intl.formatMessage({
            defaultMessage: "Payment method",
            description: "paymentMethod",
          })}
        </dt>
        <dd className="text-end font-bold">
          {intl.formatMessage({ defaultMessage: "Qi", description: "qiCard" })}
        </dd>

        <dt className="text-text-disabled-primary">
          {intl.formatMessage({
            defaultMessage: "Total price",
            description: "trips.totalPrice",
          })}
        </dt>
        <dd className="text-end font-bold">{formatCurrency(totalPrice)}</dd>
      </dl>
    </CollapsibleCard>
  );
}
